import { useEngineStore } from "@/stores/EngineStore/EngineStore.ts";
import { AppPage } from "@/stores/EngineStore/enums/AppPage.ts";
import { useEffect, useRef } from "react";

export const useResetCardOnNavigateBack = (resetCreditCardFields: () => void) => {
  const page = useEngineStore((state) => state.page);

  const resetCardRef = useRef(resetCreditCardFields);
  resetCardRef.current = resetCreditCardFields;

  const prevPageRef = useRef(page);
  useEffect(() => {
    const prevPage = prevPageRef.current;
    prevPageRef.current = page;

    if (prevPage === AppPage.ReservationOverview && page !== AppPage.PaymentResult) {
      resetCardRef.current();
    }
  }, [page]);
};
